var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 1.20001H1.2C0.54 1.20001 0.00599999 1.74001 0.00599999 2.40001L0 9.60001C0 10.26 0.54 10.8 1.2 10.8H10.8C11.46 10.8 12 10.26 12 9.60001V2.40001C12 1.74001 11.46 1.20001 10.8 1.20001ZM10.56 3.75001L6.318 6.40201C6.126 6.52201 5.874 6.52201 5.682 6.40201L1.44 3.75001C1.29 3.65401 1.2 3.49201 1.2 3.31801C1.2 2.91601 1.638 2.67601 1.98 2.88601L6 5.40001L10.02 2.88601C10.362 2.67601 10.8 2.91601 10.8 3.31801C10.8 3.49201 10.71 3.65401 10.56 3.75001Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.50956de40ac048256520e435a855e2e0.svg";
export { ForwardRef as ReactComponent };